export default {
      id: "unit-list-shock-usage",
      viewBox: "0 0 11 9",
      url: __webpack_public_path__ + "img/icons.svg#unit-list-shock",
      toString: function () {
        return this.url;
      }
    }